/* ==========================================================================
   DTFJOKER — Price-card selector collapse/expand only.
   Selection itself is 100% native radios wired to Dawn's variant-selects, so
   price / inventory / Add to Cart are unchanged. This script ONLY:
     • measures whether the grid's real content overflows the CSS max-height cap,
     • shows the fade + "Show All" toggle only when it actually overflows
       (no dead UI when all cards already fit),
     • toggles the .is-expanded class (a class flip, no layout rebuild).
   No new network requests. A few hundred bytes.
   ========================================================================== */
(function () {
  'use strict';

  class PriceCards extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;

      this.grid = this.querySelector('[data-pcards-grid]');
      this.toggle = this.querySelector('[data-pcards-toggle]');
      this.toggleLabel = this.querySelector('[data-pcards-toggle-label]');
      if (!this.grid || !this.toggle) return;

      this.toggle.addEventListener('click', this.onToggle.bind(this));

      // Measure after layout/fonts settle so height is accurate.
      this.measure = this.measure.bind(this);
      requestAnimationFrame(this.measure);
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(this.measure);
      }
      window.addEventListener('resize', debounce(this.measure, 150));
    }

    measure() {
      // Don't re-cap while expanded.
      if (this.classList.contains('is-expanded')) return;
      // scrollHeight = full content; clientHeight = capped visible area.
      var overflowing = this.grid.scrollHeight - this.grid.clientHeight > 2;
      this.classList.toggle('is-overflowing', overflowing);
      this.toggle.hidden = !overflowing;
      if (overflowing) {
        var hiddenApprox = this.countHiddenRows();
        this.toggleLabel.textContent = hiddenApprox
          ? 'Show All Sizes (+' + hiddenApprox + ' more)'
          : 'Show All Sizes';
      }
    }

    // Rough count of cards below the fold (for the "+N more" hint).
    countHiddenRows() {
      var cards = this.grid.querySelectorAll('.dtfj-pcard');
      var capBottom = this.grid.getBoundingClientRect().top + this.grid.clientHeight;
      var hidden = 0;
      cards.forEach(function (c) {
        if (c.getBoundingClientRect().top >= capBottom - 4) hidden++;
      });
      return hidden;
    }

    onToggle() {
      var expanded = this.classList.toggle('is-expanded');
      this.toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      this.toggleLabel.textContent = expanded ? 'Show Less' : 'Show All Sizes';
      // Update the chevron sibling if present.
      var chev = this.toggle.querySelector('span[aria-hidden="true"]');
      if (chev) chev.textContent = expanded ? '▲' : '▾';
    }
  }

  function debounce(fn, ms) {
    var t;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, ms);
    };
  }

  if (!customElements.get('price-cards')) {
    customElements.define('price-cards', PriceCards);
  }
})();
